import { useEffect, useMemo } from "react";
import { useProjectActions, useProjectContext } from "@contexts/projects";
import { buildProjectionRequestKey } from "@contexts/projects/projectionScope";
import ProjectionLoadState from "@components/dashboard/financialProjection/ProjectionLoadState";
import ServiceAccordion from "./ServiceAccordion";
import AccordionItem from "./AccordionItem";

const SubstepAccordion = ({ parent, parentLabel, filters, path = [], containerId }) => {
  const { activeProject: { _id, substeps = {} }, projectionLoads = {} } = useProjectContext();
  const { loadSubsteps } = useProjectActions();
  const stepSubsteps = useMemo(() => substeps[parent], [parent, substeps]);
  const substepLoad = projectionLoads[buildProjectionRequestKey("substeps", parent)];

  useEffect(() => {
    if (_id && !stepSubsteps && !substepLoad) loadSubsteps(parent);
  }, [_id, parent, stepSubsteps, substepLoad, loadSubsteps]);

  return (
    <>
      <ProjectionLoadState
        level="substeps"
        parent={parent}
        parentLabel={parentLabel}
        isMissing={!stepSubsteps}
        onRetry={() => loadSubsteps(parent)}
        focusTargetId={containerId}
        showErrorCode
      />
      {stepSubsteps?.map((item) => (
        <AccordionItem
          key={item.wbs_code_id}
          item={item}
          type="substep"
          typeTitle="Subetapa"
          ChildAccordionComponent={ServiceAccordion}
          filters={filters}
          path={path}
        />
      ))}
    </>
  );
};

export default SubstepAccordion;
